import React from 'react';

import { SVGComponentProps } from './svg.types';

const CustomTextSvg = ({
  fill = 'currentColor',
  size = '1em',
  wrapperClass,
  ...otherProps
}: SVGComponentProps) => {
  return (
    <span className={`inline-block ${wrapperClass || ''}`}>
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...otherProps}
      >
        <path
          d="M17.5 4.375H2.5C2.15833 4.375 1.875 4.09167 1.875 3.75C1.875 3.40833 2.15833 3.125 2.5 3.125H17.5C17.8417 3.125 18.125 3.40833 18.125 3.75C18.125 4.09167 17.8417 4.375 17.5 4.375Z"
          fill={fill}
        />
        <path
          d="M17.5 8.54199H2.5C2.15833 8.54199 1.875 8.25866 1.875 7.91699C1.875 7.57533 2.15833 7.29199 2.5 7.29199H17.5C17.8417 7.29199 18.125 7.57533 18.125 7.91699C18.125 8.25866 17.8417 8.54199 17.5 8.54199Z"
          fill={fill}
        />
        <path
          d="M17.5 12.708H2.5C2.15833 12.708 1.875 12.4247 1.875 12.083C1.875 11.7413 2.15833 11.458 2.5 11.458H17.5C17.8417 11.458 18.125 11.7413 18.125 12.083C18.125 12.4247 17.8417 12.708 17.5 12.708Z"
          fill={fill}
        />
        <path
          d="M17.5 16.875H2.5C2.15833 16.875 1.875 16.5917 1.875 16.25C1.875 15.9083 2.15833 15.625 2.5 15.625H17.5C17.8417 15.625 18.125 15.9083 18.125 16.25C18.125 16.5917 17.8417 16.875 17.5 16.875Z"
          fill={fill}
        />
      </svg>
    </span>
  );
};

export default CustomTextSvg;
